import * as THREE from 'three';
import React, { useEffect } from "react";
import { useGLTF, useTexture } from '@react-three/drei'
import yellow from './yellow.jpg';

export function Samsung(props) {
  const { nodes, materials } = useGLTF('/models/GalaxyS10.glb')
  const texture = useTexture(yellow);

  useEffect(() => {
    Object.entries(materials).map((material) => {
      // these are the material names that can't be changed color
      if (
        // true||
        material[0] === "Screen,glass" || material[0] === 'glass' || material[0] === 'Diod.glass'
      ) {
        material[1].color = new THREE.Color(props.item ? props.item.color[0] : '#000000');
      }
      material[1].needsUpdate = true;
    });
  }, [materials, props.item]);
  
  return (
    <group {...props} dispose={null}>
      <group position={[0, 0.078, 0]} rotation={[0, -1.6, -Math.PI / 2]}>
        {/* <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube005.geometry}
          material={materials['Screen,glass']}
        /> */}

        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube005_1.geometry}
          material={materials.Body}
        />

        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube005_2.geometry}
          material={materials.glass}
        />

        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube005_3.geometry}
          material={materials['Metall.paint']}
        />
        
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.back.geometry}
          material={materials['Material.007']}
          position={[-0.052, -0.005, 0]}
          rotation={[0, -Math.PI / 2, 0]}
          scale={-1}
        />
        <group position={[-0.067, 0.003, -0.027]} rotation={[-Math.PI, 0, Math.PI / 2]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube004.geometry}
            material={materials.lense}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube004_1.geometry}
            material={materials.Black_rought}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube004_2.geometry}
            material={materials['Material.006']}
          />
        </group>
        <group position={[-0.051, -0.003, -0.017]} rotation={[-Math.PI, 0, Math.PI / 2]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube006.geometry}
            material={materials.lense}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube006_1.geometry}
            material={materials.Black_rought}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube006_2.geometry}
            material={materials['Material.006']}
          />
        </group>
        <group position={[-0.051, -0.003, -0.006]} rotation={[-Math.PI, 0, Math.PI / 2]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube007.geometry}
            material={materials.lense2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube007_1.geometry}
            material={materials.Black_rought}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube007_2.geometry}
            material={materials['Material.006']}
          />
        </group>
        <group position={[-0.051, -0.003, 0.005]} rotation={[-Math.PI, 0, Math.PI / 2]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube008.geometry}
            material={materials.lense}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube008_1.geometry}
            material={materials.Black_rought}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube008_2.geometry}
            material={materials['Material.006']}
          />
        </group>
        <group position={[-0.052, -0.004, 0.013]} rotation={[Math.PI, Math.PI / 2, 0]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle001.geometry}
            material={materials['Diod.glass']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle001_1.geometry}
            material={materials.Diod}
          />
        </group>
        <group rotation={[-Math.PI, 0, Math.PI / 2]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane.geometry}
            material={materials.frame}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane_1.geometry}
            material={materials['Material.004']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane_2.geometry}
            material={materials['Material.003']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane_3.geometry}
            material={materials.steel}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane_4.geometry}
            material={materials['Metall.paint']}
          />
        </group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Framecam.geometry}
          material={materials.Body}
          position={[-0.052, -0.005, 0]}
          rotation={[0, -Math.PI / 2, 0]}
          scale={-1}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.framein.geometry}
          material={materials['frame.in']}
          position={[0, -0.014, 0]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.glass.geometry}
          material={materials.glass}
          position={[-0.052, -0.004, 0]}
          rotation={[0, -Math.PI / 2, 0]}
          scale={-1}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.glassunder.geometry}
          material={materials['Black.glass']}
          position={[-0.052, -0.004, 0]}
          rotation={[0, -Math.PI / 2, 0]}
          scale={-1}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.screenin.geometry}
          material={materials['Screen.in']}
        />
        <group position={[-0.052, -0.004, 0.017]} rotation={[-Math.PI, Math.PI / 2, 0]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane003.geometry}
            material={materials['Material.007']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane003_1.geometry}
            material={materials['Material.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane003_2.geometry}
            material={materials['Material.005']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane003_3.geometry}
            material={materials['Material.008']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane003_4.geometry}
            material={materials['Material.009']}
          />
        </group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.speaker.geometry}
          material={materials['Metall.paint']}
          position={[-0.074, -0.003, 0]}
          rotation={[-Math.PI, 0, Math.PI / 2]}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/GalaxyS10.glb')
